import React from "react"
import GeoModalPortal from "./ModalPortal.js"

const UIkit = require("../../../uikit/dist/js/uikit.min.js")
const redirect = "https://www.kadenair.com?ref=" + Date.now();
class GeoRedirect extends React.Component {

  getLocationData() {
    if (! this.getBypassCheck()) {
      fetch('https://api.bigdatacloud.net/data/reverse-geocode-client')
      .then(function(response) {
        return response.json()
      })
      .then(function(json) {
        if (json.countryCode == "US") {
          UIkit.modal("#modal-center").show()
        };
      })
      .catch(function(ex) {
        console.log('geolocation-db parsing failed', ex)
      })
    };
  }

  componentDidMount() {

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const refUrl = urlParams.get('ref')

    if (!refUrl) {
      this.getLocationData();
    } else {
      this.setBypassCheck();
    };

  }
  
  locationStay = () => {
    this.setBypassCheck();
    UIkit.modal("#modal-center").hide()
  };

  locationGo = () => {
    window.location.href = redirect;
  };
  
  setBypassCheck() {
    sessionStorage.setItem('bypassGeoLocCheck', true);
  }

  getBypassCheck() {
    return sessionStorage.getItem('bypassGeoLocCheck');
  }

  render() {
    const geoModal = (
      <GeoModalPortal>
        <style>
          {`
            #modal-center {
              background-color: rgba(0,0,0,0.3);
            }
            #modal-center .uk-modal-close-default {
              width: 40px;
              height: 40px;
              padding: 0;
              background-color: #ffffff;
              border: 1px solid #004a60;
              display:flex;
              cursor: pointer;
            }
            #modal-center .uk-modal-close-default:hover {
              color: white;
              background-color: #004a60;
              transition: 0.2s;
            }
            #modal-center button.uk-border-pill {
              padding: 10px 30px;
              border: none;
              background-color: #fff;
              color: #004a60;
              display: inline-block;
              height: 60px;
              margin-right:10px;
              font-weight: 600;
              font-family: europa, sans-serif;
              cursor: pointer;
            }
            #modal-center button.uk-border-pill:hover {
              // color: white;
              background-color: #e4e4e4;
              transition: 0.2s;
            }
            #modal-center button img {
              display: none;
              margin-right: 8px;
            }
            #modal-center button.uk-border-pill.btn-focused {
              background-color: #004a60;
              padding-left: 7px;
              color: #fff;
            }
            #modal-center button.uk-border-pill.btn-focused img {
              display: inline-flex;
            }
            a#geoModalClose svg {
              align-items: center;
              margin: auto;
            }
          `}
        </style>

          <div className="uk-modal-dialog uk-modal-body uk-margin-auto-vertical uk-width-2xlarge uk-border-rounded uk-box-shadow-small uk-padding-medium">

            <h2 className="uk-heading uk-h2 uk-text-bold uk-margin-medium-top">This Kaden site doesn’t match your location.</h2>
            <p className="uk-text-p-large">Based on your location, we think you may prefer the United States website, where you’ll get regional Kaden content and offerings.</p>
            <p className="uk-margin-bottom">

              <button className="uk-border-pill uk-text-p-large uk-flex-middle btn-focused" onClick={(evt) => this.locationGo(evt)} type="button">
                <img
                  src="/images/us-flag-round.svg"
                  alt="United States flag"
                  className="uk-border-circle"
                />
                United States
              </button>
              <button className="uk-border-pill uk-text-p-large uk-flex-middle" onClick={(evt) => this.locationStay(evt)} type="button">
                <img
                  src="/images/aus-flag-round.svg"
                  alt="Australian flag"
                  className="uk-border-circle"
                />
                Australia
              </button>

            </p>

          </div>

      </GeoModalPortal>
    )

    return geoModal
  }
}

export default GeoRedirect
